import { useSelector } from 'react-redux';
import { selectUser } from '@store/accountSlice';
import { FeatureFlagType } from '@services/Schemas/FeatureFlagSchema';

/**
 * Hook to check if a feature flag is enabled for the current user.
 * Reads feature flags from the JWT token stored in the Redux state.
 *
 * @param flagType - The feature flag type to check
 * @returns true if the feature flag is enabled, false otherwise
 */
export function useFeatureFlag(flagType: FeatureFlagType): boolean {
  const user = useSelector(selectUser);
  const featureFlagIds = user?.featureFlagIds ?? [];
  return featureFlagIds.includes(flagType);
}
